import React, { useEffect, useState } from 'react';
import './Home.css';
import { FaWhatsapp } from 'react-icons/fa';
import slide1 from '../images/slide1.webp';
import slide2 from '../images/slide2.webp';
import slide3 from '../images/slide3.webp';
import slide1MobileCompact from '../images/slide1-mobile-compact.webp';
import slide2MobileCompact from '../images/slide2-mobile-compact.webp';
import slide3MobileCompact from '../images/slide3-mobile-compact.webp';
import inicioIMG from '../images/imgInicio.webp';
import inicioIMGMobile from '../images/imgInicio-mobile.webp';
import { SlArrowLeftCircle, SlArrowRightCircle } from "react-icons/sl";
import ServicePlans from './ServicePlans';
import Velatorios from './salaVelatoria.js';
import ScrollToServices from './ScrollToServices.js';
import { Flame,Heart, Cuboid,FileText,Handshake,DollarSign,Home,ArrowUpDown, Cross,Minimize2, Car } from 'lucide-react';
import { setPageMetadata } from '../seo';

// Prioriza únicamente la primera imagen del carrusel para mejorar el LCP.
// Se elige la variante adecuada al dispositivo para no descargar ambas.
const preloadFirstSlide = () => {
  if (typeof document === 'undefined') return;

  const firstSlide = window.matchMedia('(max-width: 767px)').matches
    ? slide1MobileCompact
    : slide1;

  if (document.head.querySelector(`link[rel="preload"][href="${firstSlide}"]`)) {
    return;
  }

  const preload = document.createElement('link');
  preload.rel = 'preload';
  preload.as = 'image';
  preload.href = firstSlide;
  preload.fetchPriority = 'high';
  document.head.appendChild(preload);
};

preloadFirstSlide();


export default function Start() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const totalSlides = 3;
  const [textVisible, setTextVisible] = useState(false);

  useEffect(() => {
    setPageMetadata({
      title: 'Funeraria Coquimbo - Servicios Funerarios Profesionales y Humanitarios',
      description:
        'Funeraria Coquimbo ofrece servicios funerarios con compasión y profesionalismo. Estamos disponibles las 24 horas.',
      path: '/',
    });
  }, []);

  const services = [
  {
    icon: <Heart className="w-8 h-8 text-[#DBAC5B]" />,
    title: "Servicios Funerarios",
    description:
      "Servicios integrales de <span class='text-[#A0A0A0] font-semibold'>funeraria</span> para honrar la memoria de sus seres queridos con respeto y dignidad.",
  },
  {
    icon: <Car className="w-8 h-8 text-[#DBAC5B]" />,
    title: "Traslados",
    description:
      "Realizamos <span class='text-[#A0A0A0] font-semibold'>traslados</span> nacionales a cementerios y crematorios con profesionalismo y cuidado.",
  },
  {
    icon: <Flame className="w-8 h-8 text-[#DBAC5B]" />,
    title: "Cremación",
    description:
      "Servicios de <span class='text-[#A0A0A0] font-semibold'>cremación</span> en instalaciones certificadas, brindando tranquilidad y confianza.",
  },
  {
    icon: <Cross className="w-8 h-8 text-[#DBAC5B]" />,
    title: "Sepultación",
    description:
      "Coordinamos la <span class='text-[#A0A0A0] font-semibold'>sepultación</span>, cuidando cada detalle para un homenaje digno.",
  },
  {
    icon: <Minimize2 className="w-8 h-8 text-[#DBAC5B]" />,
    title: "Reducciones",
    description:
      "Gestionamos <span class='text-[#A0A0A0] font-semibold'>reducciones</span> con sensibilidad y respeto hacia sus seres queridos.",
  },
  {
    icon: <ArrowUpDown className="w-8 h-8 text-[#DBAC5B]" />,
    title: "Exhumación",
    description:
      "Realizamos <span class='text-[#A0A0A0] font-semibold'>exhumaciones</span> siguiendo todos los protocolos legales y sanitarios.",
  },
  {
    icon: <Cuboid className="w-8 h-8 text-[#DBAC5B]" />,
    title: "Féretros",
    description:
      "Amplia <span class='text-[#A0A0A0] font-semibold'>variedad de féretros</span> para elegir según sus preferencias y necesidades.",
  },
  {
    icon: <FileText className="w-8 h-8 text-[#DBAC5B]" />,
    title: "Tramitación",
    description:
      "Nos encargamos de la <span class='text-[#A0A0A0] font-semibold'>tramitación legal</span> ante el Seremi de Salud y otras instituciones.",
  },
  {
    icon: <Home className="w-8 h-8 text-[#DBAC5B]" />,
    title: "Velatorios",
    description:
      "Salas <span class='text-[#A0A0A0] font-semibold'>velatorias</span> confortables y equipadas para despedir a sus seres queridos.",
  },
  {
    icon: <Handshake className="w-8 h-8 text-[#DBAC5B]" />,
    title: "Convenios",
    description:
      "Ofrecemos <span class='text-[#A0A0A0] font-semibold'>convenios</span> para particulares e instituciones, adaptados a sus necesidades.",
  },
  {
    icon: <DollarSign className="w-8 h-8 text-[#DBAC5B]" />,
    title: "Costo Cero",
    description:
      "Contamos con <span class='text-[#A0A0A0] font-semibold'>servicios desde costo cero</span> para apoyar en momentos difíciles.",
  },
];

  
  
  
  
  

  useEffect(() => {
    const timer = setTimeout(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % totalSlides);
    }, 9000);
  
    return () => clearTimeout(timer);
  }, [currentSlide]);
  

  useEffect(() => {
    setTimeout(() => setTextVisible(true), 600);
  }, []);

  const slidesContent = [
    {
      title: "Un Homenaje con Tranquilidad y Dignidad",
      description: "Nos encargamos de cada detalle para que usted honre a su ser querido con <span style='color: #DBAC5B; font-weight: bold;'>serenidad</span> y <span style='color: #DBAC5B; font-weight: bold;'>tranquilidad</span>.",
      image: slide1,
      mobileImage: slide1MobileCompact,
      width: 1200,
      height: 1600,
    },
    {
      title: "La Confianza de las Familias Nos Avala",
      description: "Las <span style='color: #DBAC5B; font-weight: bold;'>reseñas positivas</span> de quienes nos eligen reflejan nuestro <span style='color: #DBAC5B; font-weight: bold;'>compromiso</span> y <span style='color: #DBAC5B; font-weight: bold;'>dedicación</span> en cada servicio.",
      image: slide3,
      mobileImage: slide3MobileCompact,
      width: 1200,
      height: 1600,
    },
    {
      title: "Un Tributo Respetuoso a sus Creencias",
      description: "Cada ceremonia que realizamos es única y honra las <span style='color: #DBAC5B; font-weight: bold;'>creencias</span> y los <span style='color: #DBAC5B; font-weight: bold;'>valores</span> de su familia, brindando una despedida llena de significado.",
      image: slide2,
      mobileImage: slide2MobileCompact,
      width: 1600,
      height: 1200,
    }
  ];
  
  
  
  

  return (
    <main>
     {/* Carousel */}
<div className="carousel">
  <div className="carousel-content" style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
    {slidesContent.map((slide, index) => (
      <div className={`carousel-item ${index === currentSlide ? 'show' : ''}`} key={index}>
        <picture>
          <source media="(max-width: 767px)" srcSet={slide.mobileImage} />
          <img 
            src={slide.image} 
            alt={`Fotos Funeraria Coquimbo ${index + 1}`} 
            width={slide.width}
            height={slide.height}
            loading={index === 0 ? "eager" : "lazy"} 
            fetchPriority={index === 0 ? "high" : "auto"}
            decoding="async"
          />
        </picture>
        <div className="carousel-overlay">
          <div className='px-6'>
            <p className="carousel-title text-white">{slide.title}</p>
            <p dangerouslySetInnerHTML={{ __html: slide.description }} />
            </div>
        </div>
      </div>
    ))}
  </div>
  
  <button 
    className="carousel-control previous" 
    onClick={() => setCurrentSlide((currentSlide - 1 + totalSlides) % totalSlides)}
    aria-label="Ver diapositiva anterior"
  >
    <SlArrowLeftCircle />
  </button>

  <button 
    className="carousel-control next" 
    onClick={() => setCurrentSlide((currentSlide + 1) % totalSlides)}
    aria-label="Ver siguiente diapositiva"
  >
    <SlArrowRightCircle />
  </button>

  {/* Contenedor para el indicador de scroll y los puntos del carrusel */}
<div className="scroll-and-indicators-container">
  {/* Indicador de scroll */}
  <a href="#bienvenida" aria-label="Ir a la sección de bienvenida">
    <div className="scroll-indicator">
      ↓
    </div>
  </a>

  {/* Indicadores del carrusel */}
  <div className="carousel-indicators">
    {slidesContent.map((_, index) => (
      <button
        type="button"
        key={index}
        className={`carousel-indicator ${index === currentSlide ? 'active' : ''}`}
        onClick={() => setCurrentSlide(index)}
        aria-label={`Ver diapositiva ${index + 1}`}
        aria-current={index === currentSlide ? "true" : undefined}
      ></button>
    ))}
  </div>
</div>


</div>

      {/* Sección de Bienvenida */}
      <section className={`containercss  mx-auto px-4 mb-16 lg:px-8 py-10 lg:py-20 transition-opacity duration-1000 ${textVisible ? 'opacity-100' : 'opacity-0'}`}>
  <div id='bienvenida' className="max-w-6xl mx-auto">
    <div className="flex flex-col md:flex-row items-center justify-between gap-8 md:gap-12">
      <div className="w-full md:w-1/2 space-y-6">
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6 lg:mb-8 text-gray-900 text-justify">
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-gray-700 via-gray-800 to-gray-700 text-justify">
            Bienvenido a <br></br> Funeraria Coquimbo
          </span>
        </h1>
        <p className="text-gray-500 text-justify text-lg sm:text-lg lg:text-2xl">
          En Funeraria Coquimbo, entendemos lo <span className="text-[#A0A0A0] font-bold">doloroso</span> que es despedirse de un ser querido. Nuestro equipo,
          guiado por la <span className="text-[#A0A0A0] font-bold">compasión</span> y el <span className="text-[#A0A0A0] font-bold">respeto</span>, se compromete a ofrecer un servicio personalizado que
          honre y celebre la vida de quienes han partido.
        </p>
        <p className="text-gray-500 text-justify text-lg sm:text-lg lg:text-2xl">
          Nos encargamos de que cada detalle esté <span className="text-[#A0A0A0] font-bold">cuidadosamente</span> planeado, brindándole la <span className="text-[#A0A0A0] font-bold">paz</span> y el <span className="text-[#A0A0A0] font-bold">consuelo</span> que necesita en estos momentos difíciles. Disponemos de una <span className="text-[#A0A0A0] font-bold">amplia gama de servicios</span>, como 
          servicios desde costo cero, cremaciones, exhumaciones y traslados, adaptándonos siempre a los <span className="text-[#A0A0A0] font-bold">deseos</span> y <span className="text-[#A0A0A0] font-bold">necesidades</span> de cada familia.
        </p>
        <p className="text-gray-500 text-justify text-lg sm:text-lg lg:text-2xl">
          Los invitamos a visitar nuestra sucursal en la ciudad de Coquimbo, donde podrá conocer más sobre nuestros servicios y recibir atención personalizada.
          Nos encontramos en <span className="text-[#A0A0A0] font-bold">Av. Videla #520</span>, frente al <span className="text-[#A0A0A0] font-bold">Parque 11 de Septiembre</span> y a pocos pasos del <span className="text-[#A0A0A0] font-bold">Hospital San Pablo de Coquimbo</span>.
          Nuestro equipo estará encantado de guiarle y brindarle todo el apoyo que necesite en estos momentos tan delicados.
        </p>
      </div>
      <div className="relative w-full md:w-1/2">
        <div className="absolute colorborde inset-2 border-4 transform translate-x-3 translate-y-3"></div>
        <picture>
          <source media="(max-width: 767px)" srcSet={inicioIMGMobile} />
          <img
            src={inicioIMG} 
            alt="Funeraria Coquimbo - Servicios Funerarios" 
            width="1080"
            height="1802"
            className="relative object-cover w-full h-auto p-2"
            loading="lazy"
            decoding="async"
          />
        </picture>
      </div>
    </div>
  </div>
</section>

 {/* WhatsApp Button */}
  <a
        href="https://wa.me/+56983221037"
        className="whatsapp-button"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Escríbenos por WhatsApp"
      >
        <FaWhatsapp size={50} />
      </a>
      
      {/* Plans Section */}
      <section className="plans-section" id='services'>
      <ScrollToServices />
        <ServicePlans />
      </section>

      {/* Velatorios Section */}
      <section className="velatorios-section">
        <Velatorios /> 
      </section>

      {/* Services Section */}
      <div className="flex flex-col items-center justify-center py-28 mt-1 lg:px-8  bg-gray-100  px-4">
        <section className="w-full max-w-6xl space-y-12">
        <div className="flex flex-col mb-0">
  <h2 className="text-4xl lg:text-5xl  font-bold text-left text-gray-900">
    <span className="text-transparent bg-clip-text bg-gradient-to-r from-gray-700 via-gray-800 to-gray-700 text-left">
      Servicios que ofrecemos
    </span>
  </h2>
  <p className="mt-2 text-xl text-gray-600 text-left ">
  Comprometidos a brindarte el apoyo que necesitas en cada paso.  </p>
</div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 ">
            {services.map((service, index) => (
              <div key={index} className="">
                <div className="flex items-center space-x-2 mb-3">
                  <div className="text-primary">{service.icon}</div>
                  <h3 className="text-2xl">{service.title}</h3>
                </div>
                <p className="text-gray-600" dangerouslySetInnerHTML={{ __html: service.description }} />
                </div>
            ))}
          </div>
        </section>
      </div>
    </main>
  );
}
